<div class="app-picture" [ngClass]="{'app-picture--ratio': !!ratio}" [ngStyle]="{paddingBottom: ratio * 100 + '%'}">
    <picture>
        <ng-container *ngIf="data">
            <source *ngFor="let item of data?.sources" srcset="{{ item.srcSet }}" media="{{ item.media }}">
            <img [ngStyle]="style" src="{{ data.src }}" [width]="data.width" [height]="data.height" [alt]="data.alt" loading="lazy" />
        </ng-container>
        <ng-container *ngIf="!data">
          {{ 'image.NoImage' | translate }}
        </ng-container>
    </picture>
</div>
